package org.matthewo.recharts.type

object AxisType {

    val number: AxisType
        get() = "number".unsafeCast<AxisType>()

    val category: AxisType
        get() = "category".unsafeCast<AxisType>()
}
